import React, { Component, Fragment } from "react";

import Pagination from "../../Pagination/Pagination";

import "./Orders.css";

class Orders extends Component {
    constructor(props) {
        super(props);

        this.get_data = this.get_data.bind(this);
        this.on_page_change = this.on_page_change.bind(this);
    }

    on_page_change(count, page) {
        this.setState({ page });
        this.get_data(count, page);
    }

    get_data(count, page) {
        let { connection, toast } = this.props;

        connection
            .get_orders(count, page)
            .then((res) => {
                let { orders, page, total } = res.data;
                this.setState({ orders, page, total });
            })
            .catch((err) => {
                toast(
                    "خطا در دریافت اطلاعات",
                    "سفارش ها بارگزاری نشدند",
                    " danger"
                );
            });
    }

    componentDidMount() {
        let { count, page } = this.state;
        this.get_data(count, page);
    }
    state = { orders: null, total: null, page: null, count: 4 };
    render() {
        let { orders, total, page, count } = this.state;
        return (
            <div className="OrdersComponent">
                <div className="OrdersContainer">
                    {orders && orders.length > 0 ? (
                        <Fragment>
                            <div className="orders">
                                {orders &&
                                    orders.map((o, index) => {
                                        return (
                                            <div className="order" key={index}>
                                                <a
                                                    href={"follow-up/" + o.id}
                                                    className="id text primary"
                                                >
                                                    {o.id}
                                                </a>
                                                <div className="items">
                                                    {o.items.map((item) => {
                                                        return (
                                                            <div
                                                                className="item "
                                                                key={item.id}
                                                            >
                                                                <a
                                                                    href={
                                                                        "/item/" +
                                                                        item.id
                                                                    }
                                                                    className="name text secondary"
                                                                >
                                                                    {item.name}
                                                                </a>
                                                                <div className="amount text info">
                                                                    {"("}
                                                                    {
                                                                        item.amount
                                                                    }
                                                                    <div className="unit">
                                                                        {
                                                                            item.unit
                                                                        }
                                                                    </div>
                                                                    {")"}
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                <div className="date">
                                                    {new Date(
                                                        o.time
                                                    ).toLocaleString("fa-IR")}
                                                </div>
                                                <div className="status">
                                                    {
                                                        <div className="value">
                                                            <i
                                                                className={
                                                                    (o.status ===
                                                                        "checkOut" &&
                                                                        "fa-solid fa-list-check text info") ||
                                                                    (o.status ===
                                                                        "notPayed" &&
                                                                        "fa-solid fa-money-bill-wave text warning") ||
                                                                    (o.status ===
                                                                        "pending" &&
                                                                        "fa-solid fa-spinner text confirm") ||
                                                                    (o.status ===
                                                                        "sent" &&
                                                                        "fa-solid fa-truck-fast text primary")
                                                                }
                                                            ></i>
                                                            {(o.status ===
                                                                "checkOut" && (
                                                                <div className="state text info">
                                                                    در حال چک
                                                                    کردن
                                                                </div>
                                                            )) ||
                                                                (o.status ===
                                                                    "notPayed" && (
                                                                    <div className="state text warning">
                                                                        پرداخت
                                                                        نشده
                                                                    </div>
                                                                )) ||
                                                                (o.status ===
                                                                    "pending" && (
                                                                    <div className="state text confirm">
                                                                        در حال
                                                                        انجام
                                                                    </div>
                                                                )) ||
                                                                (o.status ===
                                                                    "sent" && (
                                                                    <div className="state text primary">
                                                                        ارسال
                                                                        شده
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    }
                                                </div>
                                                <div className="follow-up">
                                                    <a
                                                        href={
                                                            "follow-up/" + o.id
                                                        }
                                                        className="btn info"
                                                    >
                                                        <i className="fa-regular fa-eye"></i>
                                                        مشاهده / پیگیری
                                                    </a>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                            <div className="pagination">
                                {total && page !== null && count && (
                                    <Pagination
                                        count={count}
                                        page={page}
                                        total={total}
                                        on_page_change={(p) =>
                                            this.on_page_change(count, p)
                                        }
                                    />
                                )}
                            </div>
                        </Fragment>
                    ) : (
                        <div className="no_order text danger">
                            <i className="ri-close-circle-line "></i>
                            هنوز سفارشی ثبت نکرده اید. (چرا واقعا ؟؟؟)
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default Orders;
